// extracted by mini-css-extract-plugin
export default {"Item":"Item_Item__PrfAz","title":"Item_title__BRF8C","info":"Item_info__+Wsbn","file":"Item_file__94WlA","content":"Item_content__dvTLH"};